// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3PV7-","table":"List_table__1uQ5R","sorted":"List_sorted__2Nfd0","increaseButton":"List_increaseButton__1I9ff","popUpAlign":"List_popUpAlign__3yt9f"};